import React from 'react'
import { HeroSection } from '../components/HeroSection/HeroSectionSignUp'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useUrlSearchParam } from '@/hooks'

const useRedirectToWhiteLabelIfNeeded = () => {
  const { utility } = useParams()
  if (utility !== undefined) return
  const listing = useUrlSearchParam('listing')
  if (!listing) return
  const location = useLocation()
  const history = useHistory()
  history.replace(`/${listing}${location.pathname}`)
}

export default function SignUp() {
  useRedirectToWhiteLabelIfNeeded()
  const { programId } = useParams()
  const programIdNum =
    programId != null && programId !== '' ? parseInt(programId, 10) : null
  const isValidProgramId =
    programIdNum != null && !Number.isNaN(programIdNum) && programIdNum > 0

  return (
    <React.Fragment>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_CAPTCHA_SITE_KEY ?? ''}
      >
        <HeroSection programId={isValidProgramId ? programIdNum : null} />
      </GoogleReCaptchaProvider>
    </React.Fragment>
  )
}
